import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './styles.module.css';
import { ReactComponent as HomeIcon } from "../../assets/home-icon.svg";
import { ReactComponent as HelpIcon } from "../../assets/help-icon.svg";
import { ReactComponent as DownloadIcon } from "../../assets/download-icon.svg";
import { ReactComponent as ReferIcon } from "../../assets/refer-icon.svg";
import { ReactComponent as HomeFilledIcon } from "../../assets/home-filled-icon.svg";
import { ReactComponent as HelpFilledIcon } from "../../assets/help-filled-icon.svg";
import { ReactComponent as DownloadFilledIcon } from "../../assets/donwload-filled-icon.svg";
import { ReactComponent as ReferFilledIcon } from "../../assets/refer-filled-icon.svg";
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { CLEVERTAP_EVENTS, NAVIGATION_ROUTES } from '../../constant';
import { pushClevertapEvent } from '../../utils/analytics/clevertap';

interface FooterLink {
  path: string;
  label: string;
  icon: React.ReactNode;
  filledIcon: React.ReactNode;
  onClick?: () => void;
}

const Footer: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const links: FooterLink[] = [
    { 
      path: NAVIGATION_ROUTES.HOME, 
      label: t('play'), 
      icon: <HomeIcon />, 
      filledIcon: <HomeFilledIcon /> 
    },
    // { 
    //   path: NAVIGATION_ROUTES.REFER, 
    //   label: t('refer'), 
    //   icon: <ReferIcon />, 
    //   filledIcon: <ReferFilledIcon /> 
    // },
    { 
      path: NAVIGATION_ROUTES.DOWNLOAD, 
      label: t('download'), 
      icon: <DownloadIcon />, 
      filledIcon: <DownloadFilledIcon /> 
    },
    { 
      path: NAVIGATION_ROUTES.HELP, 
      label: t('help'), 
      icon: <HelpIcon />, 
      filledIcon: <HelpFilledIcon />,
      onClick: () => {
        pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_CLICK_HELP);
      }
    }
  ];

  const isActiveLink = (path: string) => location.pathname === path;

  return (
    <footer className={styles.footer}>
      {links.map(({ path, label, icon, filledIcon, onClick }) => (
        <NavLink
          key={path}
          to={path}
          className={clsx(isActiveLink(path) ? styles.active : styles.link, "link fontSizeXs fontWeightBold")}
          onClick={onClick}
        >
          <span className={clsx(styles.icon)}>
            {isActiveLink(path) ? filledIcon : icon}
          </span>
          {label}
        </NavLink>
      ))}
    </footer>
  );
};

export default Footer;
